import cx from "classnames";
import type { ComponentProps, ReactNode } from "react";
import { Button, Flex } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

type CuratedButtonProps = Omit<ComponentProps<typeof Button>, "size">;

export const RSBPrimaryButton = ({ children, ...props }: CuratedButtonProps) => (
  <Button modifier="primary" size="medium" {...props}>
    {children ?? appstr("Save")}
  </Button>
);

export const RSBSecondaryButton = ({ children, ...props }: CuratedButtonProps) => (
  <Button modifier="tertiary" size="medium" {...props}>
    {children ?? appstr("Cancel")}
  </Button>
);

type RSBFooterProps = {
  children: ReactNode;
  leftSlot?: ReactNode;
  preButtonText?: ReactNode;
  className?: string;
};

export const RSBFooter = ({ children, leftSlot, className, preButtonText }: RSBFooterProps) => (
  <Flex
    className={cx("rsb-footer", "sidebar-content-item--divider", className)}
    direction="column"
    padding="16px"
    gap="8px"
  >
    {preButtonText}
    <Flex
      direction="row"
      className={"rsb-footer-buttons"}
      justifyContent={leftSlot ? "space-between" : "flex-end"}
      width={"100%"}
      alignItems="center"
      style={{ alignSelf: "flex-end" }}
    >
      {leftSlot}
      <Flex gap="12px" alignItems="center">
        {children}
      </Flex>
    </Flex>
  </Flex>
);
